import React, { useEffect, useRef, useState } from "react";

import st from "./members.module.css";

const Members = () => {
  const [users, setUsers] = useState([]);

  const getUsers = async () => {
    const fetching = await fetch("https://jsonplaceholder.typicode.com/users");
    const res = await fetching.json();
    console.log(res);
    setUsers(res);
  };

  const usCont = useRef(null);

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <section className={st.member_section}>
      <div ref={usCont} className={st.users_container}>
        {users &&
          users.map((user) => (
            <button className={st.user} key={user.id}>
              <img
                src="https://cdn.pixabay.com/photo/2020/07/01/12/58/icon-5359553_1280.png"
                alt=""
              />
              <p>{user.name}</p>
            </button>
          ))}
      </div>
    </section>
  );
};

export default Members;
